import request from '@/config/axios'

// 礼宾服务请求 VO
export interface ConciergeRequestVO {
  id: string | number
  memberId: string | number
  shopId: string | number
  shopName: string
  serviceType: string
  serviceName: string
  contactName: string
  contactPhone: string
  details: string
  status: string
  createTime: Date
}

// 获取礼宾服务请求分页
export function getConciergePage(params: any) {
  return request.get({ url: '/hotel/concierge/page', params })
}

// 更新礼宾服务请求状态（CONFIRMED / COMPLETED / CANCELLED）
export function updateConciergeStatus(id: string | number, status: string) {
  return request.put({ url: '/hotel/concierge/update-status', data: { id, status } })
}
